import { LoadingButton } from '@mui/lab';
import {
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    Typography,
    Alert,
    FormControl,
    Select,
    MenuItem,
} from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import CloseIcon from '@mui/icons-material/Close';
import { AddPlusIcon } from '../../../vectors/index';
import { Add } from '@mui/icons-material';
import { useAssignCompany } from '../hooks/useAssignCompany';
import { useGetAssignCompaniesList } from '../hooks/useGetAssignCompaniesList';
import { mapPlanStatusAndColor } from '@utils/companyHelper';

type AssignCompanyModalProps = {
    handleClose: () => void;
    templateId: number
};

const AssignCompanyModal: FC<AssignCompanyModalProps> = ({ handleClose, templateId }) => {
    const [errorText, setErrorText] = useState<string>('');
    const [selectedCompany, setSelectedCompany] = useState<number | string>('');
    const [companiesData, setCompaniesData] = useState<any[]>([]);
    const { companiesList, isLoadingCompaniesList } = useGetAssignCompaniesList({ setErrorText, assigned: 1, templateId: templateId })

    useEffect(() => {
        if (companiesList?.object) {
            const updatedCompaniesData = mapPlanStatusAndColor(companiesList?.object);
            setCompaniesData(updatedCompaniesData);
        }
    }, [companiesList]);

    const { assignCompany, isAssigningCompany } = useAssignCompany({ setErrorText });


    const handleAdd = () => {
        const options = {
            onSuccess: (data: { message: string }) => {
                toast.success(data.message);
                handleClose();
            },
        };
        assignCompany({
            company_id: selectedCompany,
            template_id: templateId
        }, options);
    };

    return (
        <Dialog
            open
            onClose={handleClose}
            maxWidth="xs"
            fullWidth
        >
            <DialogTitle>
                <IconButton sx={{ position: 'absolute', top: 5, right: 5 }} onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
                <br />
                <AddPlusIcon />
                <br />
                <Typography variant="h4">
                    Assign Company
                    {selectedCompany && (
                        ` by ${companiesData.find(company => company.company_id === selectedCompany)?.name}`
                    )}
                </Typography>
            </DialogTitle>
            <DialogContent>
                {errorText && <Alert sx={{ margin: "10px 0" }} severity="error">{errorText}</Alert>}
                <FormControl sx={{ marginBottom: 5 }} fullWidth>
                    <Typography id="pay-rate-type-label">Select Company</Typography>
                    <Select
                        value={selectedCompany}
                        onChange={(e) => setSelectedCompany(e.target.value)}
                        displayEmpty
                        size='small'
                    >
                        <MenuItem value="" disabled>
                            Select Company
                        </MenuItem>
                        {companiesData?.map((company) => (
                            <MenuItem key={company.id} value={company.id}>
                                {company.s_name}
                                <span
                                    style={{
                                        color: '#fff',
                                        fontSize: '9px',
                                        fontWeight: '600',
                                        backgroundColor: `${company.color}`,
                                        marginLeft: '10px',
                                        padding: '1px 5px 2px',
                                        borderRadius: 5,
                                    }}
                                >
                                    {company.plan}
                                </span>
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <LoadingButton
                    loading={isAssigningCompany}
                    disabled={isAssigningCompany}
                    onClick={handleAdd}
                    fullWidth
                    startIcon={<Add />}
                    variant="contained"
                    color="primary"
                    type="submit"
                >
                    Assign
                </LoadingButton>
            </DialogContent>
        </Dialog>
    );
};

export default AssignCompanyModal;
